import EnqueryForm from "@/components/forms/EnqueryForm";
import { FormHeading, SuccessMessageType } from "@/interface/types";
import Image from "next/image";
import React from "react";

const AdmissionImage = ({ className = "" }: { className?: string }) => (
  <Image
    src="https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cpa-course/talk_to_export_desk.webp"
    alt="Miles CMA graduates celebrating at convocation"
    width={1134}
    height={722}
    className={`h-auto w-full rounded-2xl object-cover ${className}`}
    priority
  />
);

const AdmissionForm = () => (
  <EnqueryForm
    pageName="CMA"
    courseId={2}
    darkBackground={false}
    submitButtonName="Request a Callback"
    formType="Talk to Expert Form"
    isAStepperForm
    successMessage={SuccessMessageType.ACCOUNTING}
    formHeading={FormHeading.TALK_TO_AN_EXPERT}
  />
);

const MilesCpaContactUS = () => {
  return (
    <>
      <section className="w-full bg-[#F4F4F4] md:bg-white px-4 pt-6 md:pt-0">
        <div className="main_container mx-auto pt-4 rounded-2xl bg-white md:bg-inherit">
          <div className="md:bg-[#F6F6F6] md:bg-inherit rounded-[16px] grid md:grid-cols-2 md:items-center md:gap-12">
            {/* Text */}
            <div className="md:p-4 md:py-10">
              <h2 className="text-2xl md:text-[32px] font-bold text-[#333] leading-tight max-w-[600px]">
                Learn With Us{" "}
                <span className="text-[#39F] md:block">
                  Across India or Anywhere Else
                </span>
              </h2>

              <p className="text-[#333] text-sm mt-4 md:mt-8 max-w-[620px]">
                You can pursue a{" "}
                <a
                  href="https://www.mileseducation.com/cpa/cpa-coaching-in-delhi"
                  target="_blank"
                  className="text-[#39F] underline"
                >
                  CPA in Delhi
                </a>
                , travel down south to get your{" "}
                <a
                  href="https://www.mileseducation.com/cpa/cpa-course-in-kerala"
                  target="_blank"
                  className="text-[#39F] underline"
                >
                  CPA in Kochi
                </a>
                , or even head west to get your Miles{" "}
                <a
                  href="https://www.mileseducation.com/cpa/best-cpa-course-in-ahmedabad"
                  target="_blank"
                  className="text-[#39F] underline"
                >
                  CPA in Ahmedabad
                </a>
                . Miles’ state-of-the-art offices and classrooms are spread
                across other major cities, including Kolkata, Hyderabad, Mumbai,
                and Pune.
              </p>
              <p className="text-[#333] text-sm mt-3 max-w-[620px]">
                And that’s not all. Whether you're in one of these cities or
                elsewhere, our comprehensive online support system ensures you
                succeed at every step.
              </p>
              <p className="text-[#333] text-sm mt-3 max-w-[620px]">
                With the right tools, resources, and guidance powered by the
                Miles One app you can transform your CPA journey into a
                successful, globally recognized career at whichever location is
                most convenient for you.
              </p>
            </div>

            {/* Taj Mahal illustration */}
            <div className="flex justify-center mt-6 md:mt-0 md:justify-end">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/seo-pages/miles-cma/milesCMA_learnWithUS.webp"
                alt="Line art illustration of the Taj Mahal"
                width={560}
                height={430}
                className="h-auto w-full max-w-[360px] md:max-w-none"
              />
            </div>
          </div>

          {/* Photo — mobile */}
          <div className="mt-6 pb-4 md:hidden">
            <AdmissionImage />
          </div>

          <div className="mt-10 hidden md:grid md:grid-cols-[1fr_420px] md:items-start md:gap-10">
            <AdmissionImage />
            <div className="rounded-2xl border border-[#DEE7F5] bg-white p-6">
              <AdmissionForm />
            </div>
          </div>
        </div>
      </section>
      <div className="bg-[#F4F4F4] p-4 shadow-sm md:hidden">
        <div className="p-5 bg-white rounded-[16px]">
          <AdmissionForm />
        </div>
      </div>
    </>
  );
};

export default MilesCpaContactUS;
